module.exports = __webpack_public_path__ + "b188dbdcf929d8601e7fa80c3341b494.MP3";